export const ARCHIVE_TYPES = [
  "all",
  "campaigns",
  "projects",
  "kits",
  "templates",
] as const;

export type ArchiveType = (typeof ARCHIVE_TYPES)[number];

export function isArchiveType(value: string | null): value is ArchiveType {
  return ARCHIVE_TYPES.some((type) => type === value);
}

export function archiveTypeToTab(
  archiveType: ArchiveType,
): "campaign" | "project" | "lco" | undefined {
  switch (archiveType) {
    case "campaigns":
      return "campaign";
    case "projects":
      return "project";
    case "kits":
      return "lco";
    default:
      return undefined;
  }
}
